import * as agents from './agents';
import * as apiKeys from './apiKeys';
import * as auditLogs from './auditLogs';
import * as auth from './auth';
import * as byoaAgents from './byoaAgents';
import * as dashboard from './dashboard';
import * as dataContracts from './dataContracts';
import * as evals from './evals';
import * as logs from './logs';
import * as models from './models';
import * as observability from './observability';
import * as prompts from './prompts';
import * as reports from './reports';
import * as secrets from './secrets';
import * as traces from './traces';
import * as users from './users';

const APIGateway = {
  agents,
  byoaAgents,
  auth,
  dashboard,
  dataContracts,
  evals,
  models,
  observability,
  prompts,
  reports,
  secrets,
  traces,
  apiKeys,
  users,
  logs,
  auditLogs
};

export default APIGateway;

// Export types from API modules
export type { ActionLogResponse, ModelLogResponse, RequestLogResponse, ResponseLogResponse } from './logs';
export type { ProviderDetail } from './models';
export type { DashboardStats } from './dashboard';
